import app from 'app-entrypoint';

if (typeof app === 'function') {
  app();
}



//////////////////
// WEBPACK FOOTER
// /Users/ryan/Projects/texastribune/2018-primary-hotlist/config/entry.js
// module id = null
// module chunks = 